export default __webpack_public_path__ + "static/media/3_pav_Calce_120×120_ Matt_-_Riv_Trame_Calce_60x120_Matt.e1dd57f3.jpg";